
export const getStepUpChartLinks = (language, isHomeDepotActive, translatedText) => {

  const lgPrefix = "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/";
  const hdPrefix = "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/";

  const lgLinks = [
    {
      link: `${lgPrefix}${language === 'EN' ? "English/LG+Laundry+Step+Up+Chart.pdf" : "French/LG+Laundry+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.laundry
    },
    {
      link: `${lgPrefix}${language === 'EN' ? "English/LG+Fridge+Step+Up+Chart+En.pdf" : "French/LG+Fridge+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.refrigeration
    },
    {
      link: `${lgPrefix}${language === 'EN' ? "English/LG+Cooking+Step+Up+Chart+En.pdf" : "French/LG+Cooking+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.cooking
    },

    {
      link: `${lgPrefix}${language === 'EN' ? "English/LG+Dish+Step+Up+Chart+En.pdf" : "French/LG+Dish+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.dishwasher
    },

  ];

  const hdLinks = [
    {
      link: `${hdPrefix}${language === 'EN' ? "English/LG+HD+Laundry+Step+Up+Chart+En.pdf" : "French/LG+HD+Laundry+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.laundry
    },
    {
      link: `${hdPrefix}${language === 'EN' ? "English/LG+HD+Fridge+Step+Up+En.pdf" : "French/LG+HD+Fridge+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.refrigeration
    },

    {
      link: `${hdPrefix}${language === 'EN' ? "English/LG+Cooking+Step+Up+Chart+HD+En.pdf" : "French/LG+Cooking+Step+Up+Chart+HD+Fr.pdf"}`,
      text: translatedText.cooking
    },
    {
      link: `${hdPrefix}${language === 'EN' ? "English/LG+HD+Dish+Step+Up+Chart+En.pdf" : "French/LG+HD+Dish+Step+Up+Chart+Fr.pdf"}`,
      text: translatedText.dishwasher
    },

  ];

  return isHomeDepotActive ? hdLinks : lgLinks;
};

export const getTransitionsChartLinks = (language, isHomeDepotActive, translatedText) => {
  const lgLink = {
    link: language === 'EN'
      ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Model+Transitions/LG+Product+Transitions.pdf"
      : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Model+Transitions/LG+Product+Transitions+Fr.pdf",
    text: translatedText.modelTransitions
  };

  const hdLink = {
    link: language === 'EN'
      ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Model+Transitions/HD+LG+Product+Transitions.pdf"
      : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Model+Transitions/HD+LG+Product+Transitions+Fr.pdf",
    text: translatedText.modelTransitions
  };

  return isHomeDepotActive ? [hdLink] : [lgLink];
};
